import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgAppIcBefehl28 = (props) => /* @__PURE__ */ _jsxs("svg", {
	id: "Form",
	xmlns: "http://www.w3.org/2000/svg",
	width: 64,
	height: 64,
	viewBox: "0 0 64 64",
	...props,
	children: [/* @__PURE__ */ _jsx("defs", { children: /* @__PURE__ */ _jsx("style", { children: ".red{fill:#ec0016;}.black{fill:currentColor;}" }) }), /* @__PURE__ */ _jsxs("g", {
		id: "Command_28",
		children: [
			/* @__PURE__ */ _jsxs("g", {
				id: "ETCS",
				children: [
					/* @__PURE__ */ _jsx("path", {
						className: "black",
						d: "M36.47,27.54h-3.85v2.04h4.38v1.42h-6v-7.92h5.81v1.4h-4.19v1.68h3.85v1.38Z"
					}),
					/* @__PURE__ */ _jsx("path", {
						className: "black",
						d: "M44.02,23.08v1.4h-2.37v6.52h-1.67v-6.52h-2.38v-1.4h6.41Z"
					}),
					/* @__PURE__ */ _jsx("path", {
						className: "black",
						d: "M50.54,30.41c-.59.54-1.35.81-2.27.81-1.14,0-2.03-.37-2.69-1.1-.65-.73-.98-1.74-.98-3.02,0-1.38.37-2.45,1.11-3.2.64-.65,1.46-.98,2.46-.98,1.33,0,2.31.44,2.92,1.31.34.49.52.98.55,1.48h-1.65c-.11-.38-.25-.67-.41-.86-.3-.34-.75-.52-1.34-.52s-1.08.24-1.42.73c-.35.49-.52,1.17-.52,2.06s.18,1.55.55,2c.37.44.83.66,1.4.66s1.02-.19,1.33-.57c.17-.21.31-.51.42-.92h1.64c-.14.86-.51,1.56-1.1,2.11Z"
					}),
					/* @__PURE__ */ _jsx("path", {
						className: "black",
						d: "M55.74,29.86c.39,0,.71-.04.95-.13.46-.16.69-.47.69-.92,0-.26-.11-.46-.34-.61-.23-.14-.59-.26-1.08-.37l-.84-.19c-.82-.19-1.39-.39-1.71-.61-.53-.37-.8-.94-.8-1.71,0-.71.26-1.3.77-1.77s1.27-.7,2.27-.7c.83,0,1.55.22,2.13.66s.9,1.08.93,1.93h-1.59c-.03-.48-.24-.82-.62-1.02-.26-.13-.58-.2-.96-.2-.43,0-.77.09-1.02.26-.25.17-.38.41-.38.72,0,.28.12.49.38.63.16.09.5.2,1.03.33l1.36.33c.6.14,1.05.33,1.35.57.47.37.71.91.71,1.62s-.28,1.32-.83,1.8c-.55.48-1.33.72-2.34.72s-1.84-.24-2.43-.71-.89-1.12-.89-1.94h1.58c.05.36.15.63.3.81.27.33.73.49,1.38.49Z"
					})
				]
			}),
			/* @__PURE__ */ _jsx("rect", {
				className: "black",
				x: 31,
				y: 33,
				width: 28,
				height: 8,
				rx: 1,
				ry: 1
			}),
			/* @__PURE__ */ _jsxs("g", {
				id: "Train",
				children: [
					/* @__PURE__ */ _jsx("path", {
						className: "red",
						d: "M25.28,38.75c-2.69,1.99-5.23,2.8-8.77,2.8s-6.08-.81-8.77-2.8l-1.19,1.61c3.02,2.24,6,3.2,9.96,3.2s6.93-.96,9.96-3.2l-1.19-1.61Z"
					}),
					/* @__PURE__ */ _jsx("path", {
						className: "black",
						d: "M27.87,26.04c-.35-4.85-4.99-10.04-11.33-10.04s-10.98,5.19-11.33,10.04c-.28,3.87-.24,9.61,1.52,14.98,1.62,4.92,3.33,6.97,9.81,6.97s8.19-2.06,9.81-6.97c1.77-5.37,1.8-11.11,1.52-14.98ZM24.45,40.4c-1.36,4.15-2.33,5.6-7.91,5.6s-6.55-1.45-7.91-5.6c-1.66-5.06-1.7-10.53-1.43-14.22.29-3.95,4.11-8.19,9.34-8.19s9.05,4.23,9.34,8.19c.27,3.69.23,9.15-1.43,14.22Z"
					}),
					/* @__PURE__ */ _jsx("path", {
						className: "black",
						d: "M23.29,26.02c-.32-3.36-4.41-4.25-6.77-4.25s-6.45.9-6.77,4.25c-.28,2.91.82,4.79,1.8,5.87,1.29,1.42,3.15,2.27,4.98,2.27s3.69-.85,4.98-2.27c.97-1.07,2.08-2.96,1.8-5.87ZM20.01,30.54c-.9.99-2.24,1.61-3.5,1.61s-2.59-.62-3.5-1.61c-.7-.77-1.49-2.15-1.29-4.33.23-2.42,4.74-2.44,4.78-2.44s4.55.03,4.78,2.44c.21,2.18-.58,3.56-1.29,4.33Z"
					}),
					/* @__PURE__ */ _jsx("path", {
						className: "black",
						d: "M11.74,38.81c-.44,0-.84-.29-.96-.73l-.66-2.34c-.15-.53.16-1.08.69-1.23.53-.15,1.08.16,1.23.69l.66,2.34c.15.53-.16,1.08-.69,1.23-.09.03-.18.04-.27.04Z"
					}),
					/* @__PURE__ */ _jsx("path", {
						className: "black",
						d: "M21.3,38.81c-.09,0-.18-.01-.27-.04-.53-.15-.84-.7-.69-1.23l.66-2.34c.15-.53.71-.84,1.23-.69.53.15.84.7.69,1.23l-.66,2.34c-.12.44-.53.73-.96.73Z"
					})
				]
			})
		]
	})]
});
export default SvgAppIcBefehl28;
